import { render, staticRenderFns } from "./recCourse.vue?vue&type=template&id=44fe1a5a&"
import script from "./recCourse.vue?vue&type=script&lang=js&"
export * from "./recCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports